import { VideoCard } from '@components/molecules/VideoCard/VideoCard';
import { IconBigPlayButton } from '@src/assets/icon-big-play-button';
import type { PropsWithClassProps } from '@vgn-medien-holding/vgn-fe-components';
import dynamic from 'next/dynamic';
import { twMerge } from 'tailwind-merge';

const ReactPlayer = dynamic(() => import('react-player'), { ssr: false });

export interface TrailerPlayerProps extends PropsWithClassProps<'videoCard' | 'videoText'> {
  /** Youtube id as delivered by the `youtube` field of a movie or show */
  youtubeId: string;
  /** Title of the movie or show, used for the caption below the player */
  title?: string;
  copyright?: string;
}

export const TrailerPlayer = ({ youtubeId, title, copyright = 'YouTube', classProps }: TrailerPlayerProps) => {
  if (!youtubeId) return null;

  return (
    <VideoCard
      description={title ? `${title} – Trailer` : undefined}
      copyright={copyright}
      classProps={{
        root: twMerge('overflow-hidden rounded-lg bg-gray-820', classProps?.root),
        videoCard: twMerge('aspect-video', classProps?.videoCard),
        videoText: classProps?.videoText,
      }}
    >
      <ReactPlayer
        src={`https://www.youtube.com/watch?v=${youtubeId}`}
        // Only renders the youtube thumbnail until the user hits play, so no
        // youtube iframe (and no youtube cookies) are loaded up front.
        light={`https://i.ytimg.com/vi/${youtubeId}/hqdefault.jpg`}
        playIcon={<IconBigPlayButton />}
        playing
        controls
        width="100%"
        height="100%"
        style={{ position: 'absolute', inset: 0 }}
        previewTabIndex={0}
        previewAriaLabel={title ? `Trailer zu ${title} abspielen` : 'Trailer abspielen'}
      />
    </VideoCard>
  );
};
